var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-window",on:{"click":function($event){return _vm.close()}}},[_c('div',{staticClass:"overlay__frame"},[(_vm.newUrl)?_c('img',{attrs:{"src":`${this.newUrl}`}}):_vm._e(),_c('div',{staticClass:"tab-button close",attrs:{"data-translation-element":"close"}},[_vm._v("Close")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }